import { QueryClient } from "@tanstack/vue-query";

/**
 * Defaults chosen to behave like the Vuex actions they replace: always refetch, never retry.
 * `config` is spread last so tests can pass e.g. a silent `logger`.
 */
export function createQueryClient(config = {}) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        retry: 0,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: 0 },
    },
    ...config,
  });
}

export const queryClient = createQueryClient();
